export default "let purchase (purchase_price : tez) : bool =\n    // Type your solution below\n\nin true\n";